import { useAuth } from '@/contexts/AuthContext';
import ResidentHome from './ResidentHome';
import ChefDashboard from './ChefDashboard';

export default function Dashboard() {
  const { user } = useAuth();
  return user?.role === 'chef' ? <ChefDashboard /> : <ResidentHome />;
}
